import { createSelector } from "reselect";

import { RootState } from "src/types";

/**
 * Селекторы хранилища ошибки
 */
const getRoot = (state: RootState) => state.error;

/**
 * Селектор ошибки
 */
export const getErrorMessage = createSelector(
  [getRoot],
  (root) => root.errorMessage
);

/**
 * Селектор типа ошибки
 */
export const getErrorType = createSelector([getRoot], (root) => root.errorType);

export const getNotifications = createSelector(
  [getRoot],
  (root) => root.notifications
);
